import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Users, Globe, HandHeart } from 'lucide-react';
import '../styles/fonts.css';

const communityImages = [
{
  // url: 'https://plus.unsplash.com/premium_photo-1661376831448-ca91becb6f98?w=600&q=80',
  url: '/images/yoga.jpeg',
  title: 'Community Yoga Sessions'
},
{
  // url: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=600&q=80',
  url: '/images/healthcare.jpeg',
  title: 'Health Workshops'
},
{
  // url: 'https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=600&q=80',
  url: '/images/group-teamwork.jpeg',
  title: 'Group Meditation'
},
{
  // url: 'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=600&q=80',
  url: '/images/handsheartshape.jpeg',
  title: 'Volunteer Programs'
}];


const initiatives = [
{
  icon: Users,
  title: 'Free Community Classes',
  description: 'Weekly yoga and meditation sessions open to all.'
},
{
  icon: Heart,
  title: 'Health Outreach',
  description: 'Monthly community visit in underserved areas.'
},
{
  icon: Globe,
  title: 'Environmental Care',
  description: 'Sustainable practices and eco-friendly initiatives.'
},
{
  icon: HandHeart,
  title: 'Support Groups',
  description: 'Safe spaces for mental health and recovery support.'
}];


export default function CommunitySection() {
  return (
    <section id="community" className="py-24 bg-slate-50">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}>

          <span className="text-emerald-600 pt-10 text-sm font-medium uppercase tracking-wider">OUR COMMUNITY</span>
          <h2 className="text-4xl md:text-5xl font-bold kaushan-script text-gray-900 mt-3 mb-6">
            Committed to Making a <span className="text-emerald-600">Difference</span>
          </h2>
          <p className="text-gray-600 text-lg fuzzy-bubbles max-w-5xl mx-auto">
            Restorative Connections is committed to providing compassionate, high-quality care to seniors.
            Our goals are to increase strength, build muscle mass, and improve self-esteem.
            Through these efforts, we aim to help seniors achieve their highest possible functional level and enjoy the best quality of life.
            That's why we actively give back to our community through various programs and initiatives.  
          </p>
        </motion.div>

        {/* Image Gallery */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          {communityImages.map((image, index) =>
          <motion.div
            key={image.title}
            className="relative group overflow-hidden rounded-2xl aspect-square"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}>

              <img
              src={image.url}
              alt={image.title}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />

              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-4 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <p className="text-white font-medium text-sm">{image.title}</p>
              </div>
            </motion.div>
          )}
        </div>

        {/* Initiatives */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {initiatives.map((initiative, index) =>
          <motion.div
            key={initiative.title}
            className="text-center p-6 rounded-2xl bg-gradient-to-b from-gray-50 to-white border border-gray-100 hover:border-emerald-200 hover:shadow-lg transition-all duration-300"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}>

              <div className="inline-flex p-4 rounded-2xl bg-gradient-to-br from-emerald-100 to-teal-100 mb-4">
                <initiative.icon className="w-6 h-6 text-emerald-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{initiative.title}</h3>
              <p className="text-gray-600 text-sm">{initiative.description}</p>
            </motion.div>
          )}
        </div>

        {/* CTA */}
        <motion.div
          className="mt-16 text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}>

          <div className="inline-flex flex-col sm:flex-row gap-4 items-center justify-center bg-gradient-to-r from-emerald-50 to-teal-50 rounded-2xl p-8 border border-emerald-100">
            <div className="text-center sm:text-left">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Want to get involved?</h3>
              <p className="text-gray-600">Join our community initiatives and make a difference.</p>
            </div>
            <button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-6 py-3 bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-semibold rounded-full hover:shadow-lg hover:shadow-emerald-500/30 transition-all duration-300 whitespace-nowrap">

              Contact Us
            </button>
          </div>
        </motion.div>
      </div>
    </section>);

}